<template>
  <div class="front-view">
    <div class="graph-view-text">
      <div class="graph-view_title">
        <div class="front-img"></div>
        <span>{{$t(title)}}</span>
      </div>
    </div>
    <div class="graph-view_describe">
      <div class="graph-view_availablerange"><span class="graph-view_block"></span><span class="graph-view_text">{{$t(greenMsg)}}</span></div>
      <div v-if="searchTabActive === 'CurvedSurface'" class="graph-view_curveScreen"><span class="graph-view_block" :class="projectionChecked === 'OK'? 'green' : 'red'"></span><span class="graph-view_text" :class="projectionChecked === 'OK'? '' : 'red'">{{$t('T_PROJECTION') + projectionChecked }}</span></div>
    </div>
    <div class='graph-view_checkbox' >
        <div class='Projector_checkbox'>
          <el-checkbox v-model='projector_checked' ><span>{{$t('T_CHANGE_PJ_POS')}}</span></el-checkbox>
        </div>
        <div class='Screen_checkbox'>
          <el-checkbox v-model='screen_checked' :disabled= screenCheckedDisable ><span>{{$t('T_CHANGE_SCREEN_POS')}}</span></el-checkbox>
        </div>
    </div>
    <Cv
      id="frontView"
      :w="widthInit"
      :h="heightInit"
      :pjRect="pjImgRect"
      :roomRect="roomRect"
      :arrDashLines="arrDashLines"
      :arrDashRemainLines="arrDashRemainLines"
      :arrQuickCornerLines="arrQuickCornerLines"
      :arrRectLines="arrRectLines"
      :avlRect="avlRect"
      :arrHelpLines="arrHelpLines"
      :arrHelpText="arrHelpText"
      :arrCatchArea="arrCatchArea"
      :arrBlackArea="arrBlackArea"
      :arrRectHorSecLines="arrRectHorSecLines"
      :arrowRects="arrowRects"
      :arrCornerCorAreas="arrCornerCorAreas"
      :arrCurveLinesArea="arrCurveLinesArea"
      ref="frontView"
      @setArrHelpLine="setArrHelpLine"
      @removeCenter="removeCenter"
    >
    </Cv>
    <div class="graph-slider-block front-view-slider-block">
      <div class="slider-title-v" style="width: 73px;right: 5px;" :title="$t(slider1Title)">{{ $t(slider1Title) }}</div>
      <div class="slider-item">{{ slider1Msg1 }}</div>
      <el-slider
        v-model="vLensShiftData"
        :max="vLensShiftMax"
        :min="vLensShiftMin"
        vertical
        :height="slider1Height"
        :format-tooltip="formatTooltip"
        :show-tooltip= false
        :disabled="vLensShiftMax === vLensShiftMin"
        >
      </el-slider>
      <div class="slider-item" :title="$t(slider1Msg2)">{{ $t(slider1Msg2) }}</div>
      <div class="graph-view_slider-input">
        <el-input v-model.number="vLensShiftDataInput" class="side_input"  @input="testDigitalNegative($event, 'vLensShiftDataInput', 'setVlensShift')" @blur="checkRange('vLensShiftDataInput', vLensShiftMax, vLensShiftMin)" :disabled="vLensShiftMax === vLensShiftMin">
          <template slot="suffix"><span style="line-height: 26px;">{{ slider1Append }}</span></template>
        </el-input>
      </div>
    </div>
    <div type="primary" class="middle-btn" :style="{ right: '5px', top: vCenterBtnTop, transform: 'translate(0, -15px)' }" size="small" @click="toCenterV()">{{ $t('T_CENTER') }}</div>
    <div style="position: absolute;bottom: 23px;width: 100%;text-align: center;">
        <div class="slider-title-h">{{ $t(slider2Title) }}</div>
        <div class="inline">
          <el-slider
            v-model="hLensShiftData"
            :max="hLensShiftMax"
            :min="hLensShiftMin"
            :format-tooltip="formatTooltip"
            :show-tooltip= false
            class="slider-h"
            :disabled="hLensShiftMax === hLensShiftMin"
            >
          </el-slider>
          <div class="slider-input-panel">
            <el-input v-model.number="hLensShiftDataInput" class="front_input_H side_input" @input="testDigitalNegative($event,'hLensShiftDataInput', 'setHlensShift')" @blur="checkRangeH('hLensShiftDataInput', hLensShiftMax, hLensShiftMin)" :disabled="hLensShiftMax === hLensShiftMin">
              <template slot="suffix"><span style="line-height: 24px;">{{ slider2Append }}</span></template>
            </el-input>
            <div class="horizontal" :title="$t(slider2Msg2)">{{ $t(slider2Msg2) }}</div>
          </div>
        </div>
    </div>
    <div type="primary" class="middle-btn"  style="left: 50%;bottom: -13px;" size="small" @click="toCenterH()">{{ $t('T_CENTER') }}</div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
export default {
  name: 'frontView',
  data () {
    return {
      title: 'T_FRONT_VIEW',
      greenMsg: 'T_LENS_SHIFT_RANGE',
      slider1Title: 'T_LENS_SHIFT',
      slider1Msg1: '',
      slider1Msg2: 'T_VERTICAL',
      slider1Max: this.vLensShiftMax,
      slider1Min: this.vLensShiftMin,
      slider1Append: '%',
      slider2Title: 'T_LENS_SHIFT',
      slider2Msg1: '',
      slider2Msg2: 'T_HORIZONTAL',
      slider2Max: this.hLensShiftMax,
      slider2Min: this.hLensShiftMin,
      slider2Append: '%',
      child: null,

      pjImgRect: {},
      roomRect: {},
      avlRect: [],
      arrDashLines: [],
      arrDashRemainLines: [],
      arrQuickCornerLines: [],
      arrRectLines: [],
      arrCatchArea: [],
      arrBlackArea: [],
      arrHelpLines: [],
      arrHelpText: [],
      arrRectHorSecLines: [],
      arrCurveLinesArea: [],
      widthInit: 0,
      heightInit: 0,

      helpDisMin: 20,
      helpDisMax: 40,
      helpTextDis: 37,
      helpNeDis: 40,
      // 左右边辅助线文字的距离
      helpBesideDis: 35,
      slider1Height: '0px',
      slider2Height: '0px',
      vCenterBtnTop: '0px',
      vLensShiftDataInput: 0,
      hLensShiftDataInput: 0,
      arrowRects: [],
      arrCornerCorAreas: [],
      position: {
        x: 0,
        y: 0
      },
      projectionChecked: 'OK'
    }
  },
  computed: {
    ...mapState([
      'pjY',
      'pjZ',
      'graph',
      'vAngle',
      'houseInfo',
      'vAngleFlag',
      'hAngleFlag',
      'projectorChecked',
      'screenMoveChecked',
      'drawData',
      'blackDrawData',
      'lenghProInit',
      'widthProInit',
      'rangeDrawData',
      'screenSizeChecked',
      'throwDistanceChecked',
      'vLensShiftNow',
      'hLensShiftNow',
      'flToB',
      'flToL',
      'initScreenSize',
      'dashData',
      'touchWallFlag',
      'dashFlag',
      'indAngleSwitch',
      'indAngleRemainPints',
      'cornerCorAreas',
      'isTouch',
      'limitData',
      'selectedModelData',
      'isUSTWall',
      'searchTabActive',
      'curveShape',
      'curveCentralAngle',
      'curveChordLength',
      'curveScreenHeight',
      'aspectRatio',
      'curveDirection',
      'curveDepth',
      'throwDisSliderMin',
      'throwDisSliderMax',
      'screenEdgesDrawData',
      'projectionCoverScreen'
    ]),
    ...mapGetters([
      'unitLabel'
    ]),
    // coverScreenColor: {
    //   get () {
    //     console.log('coverScreenColor', this.projectionCoverScreen)
    //     return this.projectionCoverScreen ? this.$constant.greenColor : this.$constant.redColor
    //   }
    // },
    throw_distance_checked: {
      get () {
        return this.throwDistanceChecked
      }
    },
    screen_size_checked: {
      get () {
        return this.screenSizeChecked
      }
    },
    vLensShiftMax: {
      get () {
        return this.graph.vLensShift.max * 10000 / 100
      }
    },
    vLensShiftMin: {
      get () {
        return this.graph.vLensShift.min * 10000 / 100
      }
    },
    vLensShiftData: {
      get () {
        return this.vLensShiftNow
      },
      set (value) {
        this.setVlensShift(value)
      }
    },

    hLensShiftMax: {
      get () {
        return this.graph.hLensShift.max * 10000 / 100
      }
    },
    hLensShiftMin: {
      get () {
        return this.graph.hLensShift.min * 10000 / 100
      }
    },
    hLensShiftData: {
      get () {
        return this.hLensShiftNow
      },

      set (value) {
        this.setHlensShift(value)
      }
    },
    projector_checked: {
      get () {
        return this.projectorChecked
      },
      set (value) {
        if (value && this.screenMoveChecked) {
          this.SET_SCREENMOVECHECKED(false)
        }
        this.SET_PROJECTORCHECKED(value)
      }
    },
    screen_checked: {
      get () {
        return this.screenMoveChecked
      },
      set (value) {
        if (value && this.projectorChecked) {
          this.SET_PROJECTORCHECKED(false)
        }
        this.SET_SCREENMOVECHECKED(value)
      }
    },
    screenCheckedDisable: {
      get () {
        return this.throw_distance_checked || (this.hLensShiftMax === this.hLensShiftMin && this.vLensShiftMax === this.vLensShiftMin) || this.vAngleFlag || this.hAngleFlag
      }
    }
  },
  created () {
    this.widthInit = this.houseInfo.roomW
    this.heightInit = this.houseInfo.roomH
  },
  mounted () {
    this.child = this.$refs.frontView
    this.slider1Height = this.child.$refs.canvas_side.offsetHeight * 0.35 + 'px' // TODO
    this.slider2Height = this.slider1Height
    this.vCenterBtnTop = document.getElementsByClassName('front-view-slider-block')[0].offsetTop + this.child.$refs.canvas_side.offsetHeight * 0.35 * 0.5 + 55 + 'px'
    this.vLensShiftDataInput = this.vLensShiftMax === this.vLensShiftMin ? 0 : parseInt(this.vLensShiftData)
    this.hLensShiftDataInput = this.hLensShiftMax === this.hLensShiftMin ? 0 : parseInt(this.hLensShiftData)

    this.initCanvasData()
    this.$nextTick(function () {
      // this.child.drawCv()
    })
    this.unWatchDrawData = this.$watch('drawData', function () {
      this.initCanvasData()
      this.$nextTick(function () {
        this.child.onGraphChanged()
      })
    }, {deep: true})

    this.unWatchHouseInfo = this.$watch('houseInfo', function () {
      this.initCanvasData()
      this.widthInit = this.houseInfo.roomW
      this.heightInit = this.houseInfo.roomH
      this.$nextTick(function () {
        this.child.onHouseInfoChanged()
      })
    }, {deep: true})

    // this.unWatchVLensShiftData = this.$watch('vLensShiftData', (newValue, oldValue) => {
    //   this.vLensShiftDataInput = this.vLensShiftMax === this.vLensShiftMin ? 0 : Number(newValue.toFixed(0))
    // })
    // this.unWatchHLensShiftData = this.$watch('hLensShiftData', (newValue, oldValue) => {
    //   this.hLensShiftDataInput = this.hLensShiftMax === this.hLensShiftMin ? 0 : Number(newValue.toFixed(0))
    // })
    this.unWatchScreenCheckedDisable = this.$watch('screenCheckedDisable', (newValue, oldValue) => {
      if (newValue && this.screen_checked) {
        this.screen_checked = false
      }
    })
    this.unWatchSearchTabActive = this.$watch('searchTabActive', function () {
      this.initCanvasData()
      this.$nextTick(function () {
        this.child.onGraphChanged()
      })
    }, {deep: true})
  },
  destroyed () {
    this.unWatchDrawData()
    this.unWatchHouseInfo()
    // this.unWatchVLensShiftData()
    // this.unWatchHLensShiftData()
    this.unWatchScreenCheckedDisable()
    this.unWatchSearchTabActive()
  },
  methods: {
    ...mapMutations([
      'PJX',
      'PJZ',
      'SET_VLENSSHIFT',
      'SET_HLENSSHIFT',
      'SET_OLDTX',
      'SET_OLDTY',
      'SET_FLOOR2BOTTOM',
      'SET_PROJECTORCHECKED',
      'SET_SCREENMOVECHECKED',
      'SET_PJXTIP',
      'SET_PJZTIP',
      'SET_PROJECTION_COVER_SCREEN'
    ]),

    formatTooltip (val) {
      return parseInt(val)
    },

    initCanvasData () {
      if (!this.drawData) {
        return
      }
      this.widthInit = this.houseInfo.roomW
      this.heightInit = this.houseInfo.roomH
      this.arrRectPoints = this.drawData[0]
      // 房间矩形边框
      this.roomRect = null
      // 连线
      this.arrRectLines = []
      // 镜头水平倾斜时出现的第二条屏幕延伸线数组
      this.arrRectHorSecLines = []
      // 虚线
      this.arrDashLines = []
      this.arrDashRemainLines = []
      // 四角补正时，红色实线
      this.arrQuickCornerLines = []
      // 投影仪可拖动区域
      this.avlRect = []
      // 辅助线
      this.arrHelpLines = []
      // 辅助线上尺寸大小
      this.arrHelpText = []
      // 投影区域
      this.arrCatchArea = []
      // 黑边区域
      this.arrBlackArea = []
      this.arrowRects = []
      // 平面四角补正时，四个角区域
      this.arrCornerCorAreas = []
      // 曲面屏幕区域
      this.arrCurveLinesArea = []

      this.setPjRect()
      this.setArrDashLines()
      this.setArrDashRemainLines()
      this.setArrQuickCornerLines()
      this.setRoomRect()
      this.setAvlRect()
      this.setArrCatchArea()
      this.setArrQuickCornerAreas()
      // this.setArrHelpLine()
      // this.setArrHelpText()
      // this.setMiddleHelpLine()
      this.setArrBlackArea()
      // this.setArrCurveRect()
      this.setArrCurveLinesArea()
    },

    // setArrCurveRect () {
    //   if (this.searchTabActive !== 'CurvedSurface') {
    //     return
    //   }

    //   let height = this.curveShape === '0' ? this.curveChordLength : this.curveScreenHeight
    //   let width = this.curveShape === '0' ? this.curveScreenHeight : this.curveChordLength
    //   let pointLX = (this.houseInfo.roomW - width) / 2
    //   let pointRX = (this.houseInfo.roomW + width) / 2
    //   let pointTY = (this.houseInfo.roomH - height) / 2
    //   let pointBY = (this.houseInfo.roomH + height) / 2

    //   // let points = []
    //   // points.push(this.$draw.toPoint(Math.ceil(pointLX) + this.limitData, Math.ceil(pointTY) + this.limitData))
    //   // points.push(this.$draw.toPoint(Math.floor(pointRX) - this.limitData, Math.ceil(pointTY) + this.limitData))
    //   // points.push(this.$draw.toPoint(Math.floor(pointRX) - this.limitData, Math.floor(pointBY) - this.limitData))
    //   // points.push(this.$draw.toPoint(Math.ceil(pointLX) + this.limitData, Math.floor(pointBY) - this.limitData))
    //   // this.checkCurveRectStatus(points, this.arrCatchArea)
    //   // console.log('setArrCurveRect points')
    //   // this.getPointMinMaxXY(points)

    //   // let color = this.projectionChecked === 'OK' ? this.$constant.greenColor : this.$constant.redColor
    //   this.arrRectLines.push(this.$draw.toLine(pointLX, pointTY, pointRX, pointTY, this.coverScreenColor, 2))
    //   this.arrRectLines.push(this.$draw.toLine(pointRX, pointTY, pointRX, pointBY, this.coverScreenColor, 2))
    //   this.arrRectLines.push(this.$draw.toLine(pointRX, pointBY, pointLX, pointBY, this.coverScreenColor, 2))
    //   this.arrRectLines.push(this.$draw.toLine(pointLX, pointBY, pointLX, pointTY, this.coverScreenColor, 2))
    //   // console.log('roomW', this.houseInfo.roomW, 'roomH', this.houseInfo.roomH, 'curveChordLength', this.curveChordLength, 'curveScreenHeight', this.curveScreenHeight)
    // },
    setArrCurveLinesArea () {
      if (this.searchTabActive !== 'CurvedSurface' || !this.screenEdgesDrawData || this.screenEdgesDrawData.length === 0 || this.screenEdgesDrawData[0].length === 0) {
        return
      }

      let points = this.screenEdgesDrawData[0]

      // console.log('arrCurveLinesArea points')
      let pointsArr = []
      for (let i = 0; i < points.length; i++) {
        let p = {}
        p.x = points[i].x
        p.y = points[i].z
        pointsArr.push(p)
        // this.arrCurveLinesArea.push(this.$draw.toPointColor(points[i].x, points[i].z, this.coverScreenColor))
      }
      // this.getPointMinMaxXY(pointsArr)
      this.checkCurveRectStatus(pointsArr, this.arrCatchArea)
      // console.log('arrCurveLinesArea arrCatchArea')
      // this.getPointMinMaxXY(this.arrCatchArea)

      // 和setArrCurveRect函数中画的曲面屏幕区域相同(颜色设定后再画图)
      let coverScreenColor = this.projectionCoverScreen ? this.$constant.greenColor : this.$constant.redColor
      for (let i = 0; i < points.length; i++) {
        this.arrCurveLinesArea.push(this.$draw.toPointColor(points[i].x, points[i].z, coverScreenColor))
      }
    },
    getPointMinMaxXY (points) {
      let maxY = -Infinity
      let minY = Infinity
      let maxX = -Infinity
      let minX = Infinity
      points.forEach(v => {
        maxY = Math.max(maxY, v.y)
        minY = Math.min(minY, v.y)
        minX = Math.min(minX, v.x)
        maxX = Math.max(maxX, v.x)
      })
      console.log('maxY', maxY, 'minY', minY, 'minX', minX, 'maxX', maxX)
      return {
        maxY,
        minY,
        maxX,
        minX
      }
    },

    checkCurveRectStatus (points, rangeP) {
      let result = false

      // for (let i = 0; i < points.length; i++) {
      //   if (!this.$commonJs.isPointInPolygon(points[i], rangeP)) {
      //     result = true
      //     break
      //   }
      // }

      for (let i = 0; i < points.length; i++) {
        // let p = {}
        // p.x = points[i].x
        // p.y = points[i].z
        if (this.$commonJs.rayCasting(points[i], rangeP) === 'out') {
          result = true
          break
        }
      }

      // 曲面屏幕正好被投影覆盖时的投写距离
      // let xScreenSize = this.$commonViewJs.getScreenSizeByCalX(this.curveShape === '0' ? this.curveScreenHeight : this.curveChordLength, this.aspectRatio).size
      // let yScreenSize = this.$commonViewJs.getScreenSizeByCalY(this.curveShape === '0' ? this.curveChordLength : this.curveScreenHeight, this.aspectRatio).size
      // let maxScreenSize = Math.max(xScreenSize, yScreenSize)
      // let disW = this.$commonViewJs.calScreensizeToDistanceWide(maxScreenSize) - (this.curveDirection === '1' ? 1 : -1) * this.curveDepth
      // disW = Math.floor(this.$commonJs.checkRange(disW, this.throwDisSliderMin, this.throwDisSliderMax) * 10) / 10
      // let dy = Math.floor(this.$commonViewJs.getDy() * 10) / 10

      // this.projectionChecked = (result || dy < disW) ? 'NG' : 'OK'
      this.projectionChecked = (result) ? 'NG' : 'OK'
      // console.log('disW', disW, 'dy', dy, dy < disW, 'result', result, 'projectionChecked', this.projectionChecked)
      // console.log('checkCurveRectStatus projectionChecked', this.projectionChecked, result, this.$commonViewJs.getDy().toFixed(1) * 1 < disW)
      // console.log('checkCurveRectStatus projectionChecked', this.projectionChecked, result)
      this.SET_PROJECTION_COVER_SCREEN(this.projectionChecked === 'OK')
    },

    setArrQuickCornerAreas () {
      for (let i = 0; i < this.cornerCorAreas.length; i++) {
        let poArr = []
        for (let j = 0; j < this.cornerCorAreas[i].length; j++) {
          poArr.push(this.$draw.toPoint(this.cornerCorAreas[i][j].x, this.cornerCorAreas[i][j].z))
        }
        this.arrCornerCorAreas.push(poArr)
      }
    },

    setArrBlackArea () {
      // console.log(this.blackDrawData)
      if (!this.blackDrawData) {
        return
      }
      for (let i = 1; i < this.blackDrawData.length; i++) {
        for (let j = 0; j < this.blackDrawData[i].length; j++) {
          this.arrBlackArea.push(this.$draw.toPoint(this.blackDrawData[i][j].x, this.blackDrawData[i][j].z))
        }
      }
    },
    setPjRect () {
      var x = this.$commonViewJs.getAx()
      var y = this.$commonViewJs.getAz()
      var width = this.lenghProInit
      var height = this.widthProInit

      this.pjImgRect = this.$draw.toRect(x, y, width, height)
    },
    setRoomRect () {
      this.roomRect = this.$draw.toRect(
        0,
        0,
        this.houseInfo.roomW,
        this.houseInfo.roomH
      )
    },
    setAvlRect () {
      if (this.vLensShiftMax === this.vLensShiftMin) {
        return
      }
      for (let i = 0; i < this.rangeDrawData.length; i++) {
        var avlLines = this.$draw.toPoint(
          this.rangeDrawData[i].x,
          this.rangeDrawData[i].z
        )
        this.avlRect.push(avlLines)
      }
    },

    setArrCatchArea () {
      if (!this.drawData) {
        return
      }
      for (let i = 1; i < this.drawData.length; i++) {
        for (let j = 0; j < this.drawData[i].length; j++) {
          this.arrCatchArea.push(this.$draw.toPoint(this.drawData[i][j].x, this.drawData[i][j].z))
        }
      }
    },
    setArrDashLines () {
      var dashLine0 = this.$draw.toLine(0, this.$commonViewJs.getSz(), this.$commonViewJs.getRx(), this.$commonViewJs.getRz(), '#999999', 1)
      this.arrDashLines.push(dashLine0)
      var dashLine1 = this.$draw.toLine(this.$commonViewJs.getDx(), 0, this.$commonViewJs.getFx(), this.$commonViewJs.getFz(), '#999999', 1)
      this.arrDashLines.push(dashLine1)
    },
    setArrDashRemainLines () {
      // 屏幕锁定在点击倾斜角度时，获取的屏幕虚线
      var dashLine1
      if (this.dashFlag) {
        for (let i = 1; i < this.dashData.length; i++) {
          for (let j = 1; j < this.dashData[i].length; j++) {
            dashLine1 = this.$draw.toLine(this.dashData[i][j - 1].x, this.dashData[i][j - 1].z, this.dashData[i][j].x, this.dashData[i][j].z, this.$constant.dashRemainLineColor, 2)
            this.arrDashRemainLines.push(dashLine1)
          }
          if (i === this.dashData.length - 1) {
            dashLine1 = this.$draw.toLine(this.dashData[i][this.dashData[i].length - 1].x, this.dashData[i][this.dashData[i].length - 1].z, this.dashData[1][0].x, this.dashData[1][0].z, this.$constant.dashRemainLineColor, 2)
            this.arrDashRemainLines.push(dashLine1)
          } else {
            dashLine1 = this.$draw.toLine(this.dashData[i][this.dashData[i].length - 1].x, this.dashData[i][this.dashData[i].length - 1].z, this.dashData[i + 1][0].x, this.dashData[i + 1][0].z, this.$constant.dashRemainLineColor, 2)
            this.arrDashRemainLines.push(dashLine1)
          }
        }
      }
    },
    setArrQuickCornerLines () {
      var dashLine1
      // 四角补正时，画出红线
      if (this.indAngleSwitch) {
        for (let i = 0; i < this.indAngleRemainPints.length; i++) {
          if (i === this.indAngleRemainPints.length - 1) {
            dashLine1 = this.$draw.toLine(this.indAngleRemainPints[this.indAngleRemainPints.length - 1].x, this.indAngleRemainPints[this.indAngleRemainPints.length - 1].z, this.indAngleRemainPints[0].x, this.indAngleRemainPints[0].z, this.$constant.dashRemainLineColor, 1.5)
            this.arrQuickCornerLines.push(dashLine1)
          } else {
            dashLine1 = this.$draw.toLine(this.indAngleRemainPints[i].x, this.indAngleRemainPints[i].z, this.indAngleRemainPints[i + 1].x, this.indAngleRemainPints[i + 1].z, this.$constant.dashRemainLineColor, 1.5)
            this.arrQuickCornerLines.push(dashLine1)
          }
        }
      }
    },
    setMiddleHelpLine (proportion) {
      let li = 20 * proportion
      let lid = 25 * proportion
      let lia = 5 * proportion
      var downNeDis = 0
      if (this.$commonJs.changeUnitDraw(this.arrRectPoints[1].x - this.arrRectPoints[0].x, this.graph.unit, false) !== this.$commonJs.changeUnitDraw(this.arrRectPoints[2].x - this.arrRectPoints[3].x, this.graph.unit, false)) {
        downNeDis = this.helpNeDis
      }
      var middleLine0 = this.$draw.toLine(
        this.graph.pjX / 2,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + li,
        this.graph.pjX / 2,
        this.houseInfo.roomH + this.helpDisMax + downNeDis + li,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(middleLine0)
      middleLine0 = this.$draw.toLine(
        (this.houseInfo.roomW + this.graph.pjX) / 2,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + li,
        (this.houseInfo.roomW + this.graph.pjX) / 2,
        this.houseInfo.roomH + this.helpDisMax + downNeDis + li,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(middleLine0)
      middleLine0 = this.$draw.toLine(
        this.graph.pjX / 2,
        this.houseInfo.roomH + this.helpDisMax + downNeDis + li,
        (this.houseInfo.roomW + this.graph.pjX) / 2,
        this.houseInfo.roomH + this.helpDisMax + downNeDis + li,
        this.$constant.helpLineColor,
        0.8
      )
      this.arrHelpLines.push(middleLine0)
      var arrowRect0 = this.$draw.toArrow(
        this.graph.pjX / 2,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + li,
        this.graph.pjX / 2 - lia,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + lid,
        this.graph.pjX / 2 + lia,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + lid,
        this.$constant.helpLineColor
      )
      this.arrowRects.push(arrowRect0)
      arrowRect0 = this.$draw.toArrow(
        (this.houseInfo.roomW + this.graph.pjX) / 2,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + li,
        (this.houseInfo.roomW + this.graph.pjX) / 2 - lia,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + lid,
        (this.houseInfo.roomW + this.graph.pjX) / 2 + lia,
        this.houseInfo.roomH + this.helpDisMin + downNeDis + lid,
        this.$constant.helpLineColor
      )
      this.arrowRects.push(arrowRect0)
    },
    // 获取最近的点坐标
    getClosestNumber (array, target) {
      return array.reduce((pre, cur) => Math.abs(pre - target) < Math.abs(cur - target) ? pre : cur)
    },
    // 获取纵虚线和屏幕相交的点(水平曲面)
    getIntersectX () {
      // 获取纵虚线x轴的值
      var dashLineX = this.$draw.toLine(this.$commonViewJs.getDx(), 0, this.$commonViewJs.getFx(), this.$commonViewJs.getFz(), '#999999', 1).x1
      console.log('dashLineX', dashLineX)
      var intersect = {}
      // 纵虚线和屏幕上线相交的点
      if (this.drawData[1].filter((item) => item.x.toFixed(2) === dashLineX.toFixed(2)).length !== 0) {
        intersect.intersect_top = this.drawData[1].filter((item) => item.x.toFixed(2) === dashLineX.toFixed(2))[0].z
      } else {
        let topLineXArr = this.drawData[1].map((item) => {
          return item.x
        })
        console.log('topLineArr', topLineXArr)
        intersect.intersect_top = this.drawData[1].filter((item) => item.x.toFixed(2) === this.getClosestNumber(topLineXArr, dashLineX).toFixed(2))[0].z
      }
      // 纵虚线和屏幕下线相交的点
      if (this.drawData[3].filter((item) => item.x.toFixed(2) === dashLineX.toFixed(2)).length !== 0) {
        intersect.intersect_bottom = this.drawData[3].filter((item) => item.x.toFixed(2) === dashLineX.toFixed(2))[0].z
      } else {
        let bottomLineXArr = this.drawData[3].map((item) => {
          return item.x
        })
        console.log('bottomLineXArr', bottomLineXArr)
        intersect.intersect_bottom = this.drawData[3].filter((item) => item.x.toFixed(2) === this.getClosestNumber(bottomLineXArr, dashLineX).toFixed(2))[0].z
      }
      return intersect
    },

    // 获取横虚线和屏幕相交的点(垂直曲面)
    getIntersectY () {
      // 获取横虚线y轴的值
      var dashLineY = this.$draw.toLine(0, this.$commonViewJs.getSz(), this.$commonViewJs.getRx(), this.$commonViewJs.getRz(), '#999999', 1).y1
      console.log('dashLineY', dashLineY)
      var intersect = {}
      // 横虚线和屏幕右线相交的点
      if (this.drawData[2].filter((item) => item.z.toFixed(2) === dashLineY.toFixed(2)).length !== 0) {
        intersect.intersect_right = this.drawData[2].filter((item) => item.z.toFixed(2) === dashLineY.toFixed(2))[0].x
      } else {
        let rightLineZArr = this.drawData[2].map((item) => {
          return item.z
        })
        console.log('rightLineZArr', rightLineZArr)
        intersect.intersect_right = this.drawData[2].filter((item) => item.z.toFixed(2) === this.getClosestNumber(rightLineZArr, dashLineY).toFixed(2))[0].x
      }
      // 横虚线和屏幕左线相交的点
      if (this.drawData[4].filter((item) => item.z.toFixed(2) === dashLineY.toFixed(2)).length !== 0) {
        intersect.intersect_left = this.drawData[4].filter((item) => item.z.toFixed(2) === dashLineY.toFixed(2))[0].x
      } else {
        let leftLineZArr = this.drawData[4].map((item) => {
          return item.z
        })
        console.log('leftLineZArr', leftLineZArr)
        intersect.intersect_left = this.drawData[4].filter((item) => item.z.toFixed(2) === this.getClosestNumber(leftLineZArr, dashLineY).toFixed(2))[0].x
      }
      return intersect
    },
    setArrHelpLine (proportion) {
      this.helpDisMin = 10 * proportion
      this.helpDisMax = 18 * proportion
      this.helpTextDis = 20 * proportion
      this.helpNeDis = 20 * proportion
      this.helpBesideDis = 10 * proportion
      this.arrHelpLines.splice(0, this.arrHelpLines.length)
      this.arrHelpText.splice(0, this.arrHelpText.length)
      this.arrowRects.splice(0, this.arrowRects.length)
      // ================上辅助线===============
      let helpLineTop
      if (this.searchTabActive === 'CurvedSurface') {
        // スクリーン幅
        let widthV = this.curveShape === '0' ? this.curveScreenHeight : this.curveChordLength
        let pointY1 = 0 - this.helpDisMin
        let pointY2 = 0 - this.helpDisMax
        let pointY3 = 0 - (this.helpDisMin + this.helpDisMax) / 2
        let pointX1 = (this.houseInfo.roomW - widthV) / 2
        let pointX2 = (this.houseInfo.roomW + widthV) / 2
        let topPoint = [
          {start: {x: pointX1, y: pointY1}, end: {x: pointX1, y: pointY2}}, // スクリーン幅左端 的 竖线
          {start: {x: pointX2, y: pointY1}, end: {x: pointX2, y: pointY2}}, // スクリーン幅右端 的 竖线
          {start: {x: pointX1, y: pointY3}, end: {x: pointX2, y: pointY3}} // スクリーン幅左端 到  スクリーン幅右端 的 横线
        ]
        topPoint.forEach(item => {
          helpLineTop = this.$draw.toLine(item.start.x, item.start.y, item.end.x, item.end.y, this.$constant.helpLineColor, 0.8)
          this.arrHelpLines.push(helpLineTop)
        })
      } else {
        var helpLine0 = this.$draw.toLine(
          0,
          0 - this.helpDisMin,
          0,
          0 - this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        if (this.graph.pjX > 0) this.arrHelpLines.push(helpLine0)
        helpLine0 = this.$draw.toLine(
          this.arrRectPoints[0].x,
          0 - this.helpDisMin,
          this.arrRectPoints[0].x,
          0 - this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine0)
        helpLine0 = this.$draw.toLine(
          this.arrRectPoints[1].x,
          0 - this.helpDisMin,
          this.arrRectPoints[1].x,
          0 - this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine0)
        helpLine0 = this.$draw.toLine(
          this.houseInfo.roomW,
          0 - this.helpDisMin,
          this.houseInfo.roomW,
          0 - this.helpDisMax,
          this.$constant.helpLineColor,
          0.8
        )
        if (this.graph.pjX < this.houseInfo.roomW) this.arrHelpLines.push(helpLine0)
        helpLine0 = this.$draw.toLine(
          0,
          0 - (this.helpDisMax + this.helpDisMin) / 2,
          this.houseInfo.roomW,
          0 - (this.helpDisMax + this.helpDisMin) / 2,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine0)
        helpLine0 = this.$draw.toLine(
          this.arrRectPoints[0].x,
          0 - (this.helpDisMax + this.helpDisMin) / 2,
          0,
          0 - (this.helpDisMax + this.helpDisMin) / 2,
          this.$constant.helpLineColor,
          0.8
        )
        if (this.graph.pjX < 0) this.arrHelpLines.push(helpLine0)
        helpLine0 = this.$draw.toLine(
          this.arrRectPoints[1].x,
          0 - (this.helpDisMax + this.helpDisMin) / 2,
          0,
          0 - (this.helpDisMax + this.helpDisMin) / 2,
          this.$constant.helpLineColor,
          0.8
        )
        if (this.graph.pjX > this.houseInfo.roomW) this.arrHelpLines.push(helpLine0)
        if (!this.isUSTWall && this.searchTabActive === 'CurvedSurface' && this.curveShape === '0' && this.curveCentralAngle !== 0) {
          var neDisUP = 120
          var getIntersectY = this.getIntersectY()
          var helpLine4 = this.$draw.toLine(
            0,
            0 - this.helpDisMin - neDisUP,
            0,
            0 - this.helpDisMax - neDisUP,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLine4)
          helpLine4 = this.$draw.toLine(
            getIntersectY.intersect_left,
            0 - this.helpDisMin - neDisUP,
            getIntersectY.intersect_left,
            0 - this.helpDisMax - neDisUP,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLine4)
          helpLine4 = this.$draw.toLine(
            getIntersectY.intersect_right,
            0 - this.helpDisMin - neDisUP,
            getIntersectY.intersect_right,
            0 - this.helpDisMax - neDisUP,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLine4)
          helpLine4 = this.$draw.toLine(
            this.houseInfo.roomW,
            0 - this.helpDisMin - neDisUP,
            this.houseInfo.roomW,
            0 - this.helpDisMax - neDisUP,
            this.$constant.helpLineColor,
            0.8
          )
          if (this.graph.pjX < this.houseInfo.roomW) this.arrHelpLines.push(helpLine4)
          helpLine4 = this.$draw.toLine(
            0,
            0 - (this.helpDisMax + this.helpDisMin) / 2 - neDisUP,
            this.houseInfo.roomW,
            0 - (this.helpDisMax + this.helpDisMin) / 2 - neDisUP,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLine4)
        }
      }

      // ============右辅助线================
      let helpLineRight
      if (this.searchTabActive === 'CurvedSurface') {
        // スクリーン高さ
        let heightV = this.curveShape === '0' ? this.curveChordLength : this.curveScreenHeight
        let pointX1 = this.houseInfo.roomW + this.helpDisMin
        let pointX2 = this.houseInfo.roomW + this.helpDisMax
        let pointX3 = this.houseInfo.roomW + (this.helpDisMin + this.helpDisMax) / 2
        let pointY1 = (this.houseInfo.roomH - heightV) / 2
        let pointY2 = (this.houseInfo.roomH + heightV) / 2
        let rightPoint = [
          {start: {x: pointX1, y: pointY1}, end: {x: pointX2, y: pointY1}}, // スクリーン高さ上端 的 横线
          {start: {x: pointX1, y: pointY2}, end: {x: pointX2, y: pointY2}}, // スクリーン高さ下端 的 横线
          {start: {x: pointX3, y: pointY1}, end: {x: pointX3, y: pointY2}} // スクリーン高さ上端 到  スクリーン幅下端 的 竖线
        ]
        rightPoint.forEach(item => {
          helpLineRight = this.$draw.toLine(item.start.x, item.start.y, item.end.x, item.end.y, this.$constant.helpLineColor, 0.8)
          this.arrHelpLines.push(helpLineRight)
        })
      } else {
        var neDis = 0
        if (this.$commonJs.changeUnitDraw(this.arrRectPoints[3].z - this.arrRectPoints[0].z, this.graph.unit, false) !== this.$commonJs.changeUnitDraw(this.arrRectPoints[2].z - this.arrRectPoints[1].z, this.graph.unit, false)) {
          neDis = this.helpNeDis
          var helpLine10 = this.$draw.toLine(
            this.houseInfo.roomW + this.helpDisMin,
            this.arrRectPoints[1].z,
            this.houseInfo.roomW + this.helpDisMax,
            this.arrRectPoints[1].z,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLine10)
          helpLine10 = this.$draw.toLine(
            this.houseInfo.roomW + this.helpDisMin,
            this.arrRectPoints[2].z,
            this.houseInfo.roomW + this.helpDisMax,
            this.arrRectPoints[2].z,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLine10)
          helpLine10 = this.$draw.toLine(
            this.houseInfo.roomW + (this.helpDisMin + this.helpDisMax) / 2,
            this.arrRectPoints[1].z,
            this.houseInfo.roomW + (this.helpDisMin + this.helpDisMax) / 2,
            this.arrRectPoints[2].z,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLine10)
        }
        if (!this.isUSTWall && this.searchTabActive === 'Search') {
          var helpLine1 = this.$draw.toLine(
            this.houseInfo.roomW + this.helpDisMin + neDis,
            0,
            this.houseInfo.roomW + this.helpDisMax + neDis,
            0,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLine1)
          helpLine1 = this.$draw.toLine(
            this.houseInfo.roomW + this.helpDisMin + neDis,
            this.houseInfo.roomH,
            this.houseInfo.roomW + this.helpDisMax + neDis,
            this.houseInfo.roomH,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLine1)
          helpLine1 = this.$draw.toLine(
            this.houseInfo.roomW + (this.helpDisMin + this.helpDisMax) / 2 + neDis,
            0,
            this.houseInfo.roomW + (this.helpDisMin + this.helpDisMax) / 2 + neDis,
            this.houseInfo.roomH,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLine1)
        }
      }
      // 曲面スクリーン機能の改善
      // if (!this.isUSTWall && this.searchTabActive === 'CurvedSurface' && this.curveShape === '1' && this.curveCentralAngle !== 0) {
      //   var getIntersectX = this.getIntersectX()
      //   var helpLine5 = this.$draw.toLine(
      //     this.houseInfo.roomW + this.helpDisMin + neDis,
      //     0,
      //     this.houseInfo.roomW + this.helpDisMax + neDis,
      //     0,
      //     this.$constant.helpLineColor,
      //     0.8
      //   )
      //   this.arrHelpLines.push(helpLine5)
      //   helpLine5 = this.$draw.toLine(
      //     this.houseInfo.roomW + this.helpDisMin + neDis,
      //     getIntersectX.intersect_top,
      //     this.houseInfo.roomW + this.helpDisMax + neDis,
      //     getIntersectX.intersect_top,
      //     this.$constant.helpLineColor,
      //     0.8
      //   )
      //   this.arrHelpLines.push(helpLine5)
      //   helpLine5 = this.$draw.toLine(
      //     this.houseInfo.roomW + this.helpDisMin + neDis,
      //     getIntersectX.intersect_bottom,
      //     this.houseInfo.roomW + this.helpDisMax + neDis,
      //     getIntersectX.intersect_bottom,
      //     this.$constant.helpLineColor,
      //     0.8
      //   )
      //   this.arrHelpLines.push(helpLine5)
      //   helpLine5 = this.$draw.toLine(
      //     this.houseInfo.roomW + this.helpDisMin + neDis,
      //     this.houseInfo.roomH,
      //     this.houseInfo.roomW + this.helpDisMax + neDis,
      //     this.houseInfo.roomH,
      //     this.$constant.helpLineColor,
      //     0.8
      //   )
      //   this.arrHelpLines.push(helpLine5)
      //   helpLine5 = this.$draw.toLine(
      //     this.houseInfo.roomW + (this.helpDisMin + this.helpDisMax) / 2 + neDis,
      //     0,
      //     this.houseInfo.roomW + (this.helpDisMin + this.helpDisMax) / 2 + neDis,
      //     this.houseInfo.roomH,
      //     this.$constant.helpLineColor,
      //     0.8
      //   )
      //   this.arrHelpLines.push(helpLine5)
      // }

      // ============左辅助线================
      let helpLineLeft
      if (this.searchTabActive === 'CurvedSurface') {
        // スクリーン上端/下端から
        let heightV = this.curveShape === '0' ? this.curveChordLength : this.curveScreenHeight
        let pointX1 = 0 - this.helpDisMin
        let pointX2 = 0 - this.helpDisMax
        let pointX3 = 0 - (this.helpDisMin + this.helpDisMax) / 2
        let pointY1 = (this.houseInfo.roomH - heightV) / 2
        let pointY2 = this.$commonViewJs.getAz()
        let pointY3 = (this.houseInfo.roomH + heightV) / 2
        // 投影仪中心 的 横线
        let leftPoint = [{start: {x: pointX1, y: pointY2}, end: {x: pointX2, y: pointY2}}]
        if (pointY1 > pointY2) {
          // スクリーン上端 的 横线
          leftPoint.push({start: {x: pointX1, y: pointY1}, end: {x: pointX2, y: pointY1}})
          // スクリーン上端 / 投影仪中心 的 竖线
          leftPoint.push({start: {x: pointX3, y: pointY1}, end: {x: pointX3, y: pointY2}})
        } else if (pointY1 < pointY2 && pointY2 < pointY3) {
          // スクリーン上端 的 横线
          leftPoint.push({start: {x: pointX1, y: pointY1}, end: {x: pointX2, y: pointY1}})
          // スクリーン下端 的 横线
          leftPoint.push({start: {x: pointX1, y: pointY3}, end: {x: pointX2, y: pointY3}})
          // スクリーン上端 / スクリーン下端 的 竖线
          leftPoint.push({start: {x: pointX3, y: pointY1}, end: {x: pointX3, y: pointY3}})
        } else {
          // スクリーン下端 的 横线
          leftPoint.push({start: {x: pointX1, y: pointY3}, end: {x: pointX2, y: pointY3}})
          // 投影仪中心 / スクリーン下端 的 竖线
          leftPoint.push({start: {x: pointX3, y: pointY2}, end: {x: pointX3, y: pointY3}})
        }

        leftPoint.forEach(item => {
          helpLineLeft = this.$draw.toLine(item.start.x, item.start.y, item.end.x, item.end.y, this.$constant.helpLineColor, 0.8)
          this.arrHelpLines.push(helpLineLeft)
        })
      } else {
        var helpLine2 = this.$draw.toLine(
          0 - this.helpDisMin,
          0,
          0 - this.helpDisMax,
          0,
          this.$constant.helpLineColor,
          0.8
        )
        if (this.graph.pjZ > 0) this.arrHelpLines.push(helpLine2)
        helpLine2 = this.$draw.toLine(
          0 - this.helpDisMin,
          this.arrRectPoints[0].z,
          0 - this.helpDisMax,
          this.arrRectPoints[0].z,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine2)
        helpLine2 = this.$draw.toLine(
          0 - this.helpDisMin,
          this.arrRectPoints[3].z,
          0 - this.helpDisMax,
          this.arrRectPoints[3].z,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine2)
        helpLine2 = this.$draw.toLine(
          0 - this.helpDisMin,
          this.houseInfo.roomH,
          0 - this.helpDisMax,
          this.houseInfo.roomH,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine2)
        helpLine2 = this.$draw.toLine(
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          0,
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          this.houseInfo.roomH,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine2)
        helpLine2 = this.$draw.toLine(
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          this.arrRectPoints[0].z,
          0 - (this.helpDisMin + this.helpDisMax) / 2,
          0,
          this.$constant.helpLineColor,
          0.8
        )
        if (this.graph.pjZ < 0) this.arrHelpLines.push(helpLine2)
      }

      // ============下辅助线================
      let helpLineBottom
      if (this.searchTabActive === 'CurvedSurface') {
        // スクリーン左端/右端から
        let widthV = this.curveShape === '0' ? this.curveScreenHeight : this.curveChordLength
        let pointY1 = this.houseInfo.roomH + this.helpDisMin
        let pointY2 = this.houseInfo.roomH + this.helpDisMax
        let pointY3 = this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2
        let pointX1 = (this.houseInfo.roomW - widthV) / 2
        let pointX2 = this.$commonViewJs.getAx()
        let pointX3 = (this.houseInfo.roomW + widthV) / 2
        // 投影仪中心 的 竖线
        let bottomPoint = [{start: {x: pointX2, y: pointY1}, end: {x: pointX2, y: pointY2}}]
        if (pointX1 > pointX2) {
          // スクリーン左端 的 竖线
          bottomPoint.push({start: {x: pointX1, y: pointY1}, end: {x: pointX1, y: pointY2}})
          // スクリーン左端 / 投影仪中心 的 横线
          bottomPoint.push({start: {x: pointX1, y: pointY3}, end: {x: pointX2, y: pointY3}})
        } else if (pointX1 < pointX2 && pointX2 < pointX3) {
          // スクリーン左端 的 竖线
          bottomPoint.push({start: {x: pointX1, y: pointY1}, end: {x: pointX1, y: pointY2}})
          // スクリーン右端 的 竖线
          bottomPoint.push({start: {x: pointX3, y: pointY1}, end: {x: pointX3, y: pointY2}})
          // スクリーン左端 / スクリーン右端 的 横线
          bottomPoint.push({start: {x: pointX1, y: pointY3}, end: {x: pointX3, y: pointY3}})
        } else {
          // スクリーン右端 的 竖线
          bottomPoint.push({start: {x: pointX3, y: pointY1}, end: {x: pointX3, y: pointY2}})
          // 投影仪中心 / スクリーン右端 的 横线
          bottomPoint.push({start: {x: pointX2, y: pointY3}, end: {x: pointX3, y: pointY3}})
        }
        bottomPoint.forEach(item => {
          helpLineBottom = this.$draw.toLine(item.start.x, item.start.y, item.end.x, item.end.y, this.$constant.helpLineColor, 0.8)
          this.arrHelpLines.push(helpLineBottom)
        })
      } else {
        var downNeDis = 0
        if (this.$commonJs.changeUnitDraw(this.arrRectPoints[1].x - this.arrRectPoints[0].x, this.graph.unit, false) !== this.$commonJs.changeUnitDraw(this.arrRectPoints[2].x - this.arrRectPoints[3].x, this.graph.unit, false)) {
          downNeDis = this.helpNeDis
          var helpLine30 = this.$draw.toLine(
            this.arrRectPoints[2].x,
            this.houseInfo.roomH + this.helpDisMin,
            this.arrRectPoints[2].x,
            this.houseInfo.roomH + this.helpDisMax,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLine30)
          helpLine30 = this.$draw.toLine(
            this.arrRectPoints[3].x,
            this.houseInfo.roomH + this.helpDisMin,
            this.arrRectPoints[3].x,
            this.houseInfo.roomH + this.helpDisMax,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLine30)
          helpLine30 = this.$draw.toLine(
            this.arrRectPoints[2].x,
            this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2,
            this.arrRectPoints[3].x,
            this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2,
            this.$constant.helpLineColor,
            0.8
          )
          this.arrHelpLines.push(helpLine30)
        }
        var helpLine3 = this.$draw.toLine(
          0,
          this.houseInfo.roomH + this.helpDisMin + downNeDis,
          0,
          this.houseInfo.roomH + this.helpDisMax + downNeDis,
          this.$constant.helpLineColor,
          0.8
        )
        if (this.graph.pjX > 0) this.arrHelpLines.push(helpLine3)
        helpLine3 = this.$draw.toLine(
          this.graph.pjX,
          this.houseInfo.roomH + this.helpDisMin + downNeDis,
          this.graph.pjX,
          this.houseInfo.roomH + this.helpDisMax + downNeDis,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine3)
        helpLine3 = this.$draw.toLine(
          this.houseInfo.roomW,
          this.houseInfo.roomH + this.helpDisMin + downNeDis,
          this.houseInfo.roomW,
          this.houseInfo.roomH + this.helpDisMax + downNeDis,
          this.$constant.helpLineColor,
          0.8
        )
        if (this.graph.pjX < this.houseInfo.roomW) this.arrHelpLines.push(helpLine3)
        helpLine3 = this.$draw.toLine(
          0,
          this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2 + downNeDis,
          this.houseInfo.roomW,
          this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2 + downNeDis,
          this.$constant.helpLineColor,
          0.8
        )
        this.arrHelpLines.push(helpLine3)
        helpLine3 = this.$draw.toLine(
          this.graph.pjX,
          this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2 + downNeDis,
          0,
          this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2 + downNeDis,
          this.$constant.helpLineColor,
          0.8
        )
        if (this.graph.pjX < 0) this.arrHelpLines.push(helpLine3)
        helpLine3 = this.$draw.toLine(
          this.graph.pjX,
          this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2 + downNeDis,
          this.houseInfo.roomW,
          this.houseInfo.roomH + (this.helpDisMin + this.helpDisMax) / 2 + downNeDis,
          this.$constant.helpLineColor,
          0.8
        )
        if (this.graph.pjX > this.houseInfo.roomW) this.arrHelpLines.push(helpLine3)
        // this.setMiddleHelpLine(proportion)
      }
      this.setArrHelpText(proportion)
    },
    setArrHelpText (proportion) {
      let bs = 10 * proportion
      let lis = 7 * proportion
      // ==================上辅助文字===============
      var textName0, helpText0
      if (this.searchTabActive === 'CurvedSurface') {
        let widthV = this.curveShape === '0' ? this.curveScreenHeight : this.curveChordLength
        textName0 = this.$commonJs.changeUnitDraw(widthV, this.graph.unit, false)
        helpText0 = this.$draw.toText(this.houseInfo.roomW / 2, 0 - this.helpTextDis, textName0, 'top')
        this.arrHelpText.push(helpText0)
      } else {
        textName0 = this.$commonJs.changeUnitDraw(this.arrRectPoints[0].x, this.graph.unit, false)
        helpText0 = this.$draw.toText(
          this.arrRectPoints[0].x / 2,
          0 - this.helpTextDis,
          textName0,
          'top'
        )
        this.arrHelpText.push(helpText0)

        textName0 = this.$commonJs.changeUnitDraw(this.arrRectPoints[1].x - this.arrRectPoints[0].x, this.graph.unit, false)
        helpText0 = this.$draw.toText(
          (this.arrRectPoints[1].x + this.arrRectPoints[0].x) / 2,
          0 - this.helpTextDis,
          textName0,
          'top'
        )
        this.arrHelpText.push(helpText0)

        textName0 = this.$commonJs.changeUnitDraw(this.houseInfo.roomW - this.arrRectPoints[1].x, this.graph.unit, false)
        helpText0 = this.$draw.toText(
          (this.houseInfo.roomW + this.arrRectPoints[1].x) / 2,
          0 - this.helpTextDis,
          textName0,
          'top'
        )
        this.arrHelpText.push(helpText0)
      }
      textName0 = '(' + this.unitLabel + ')'
      helpText0 = this.$draw.toText(
        this.houseInfo.roomW + this.helpTextDis + this.helpBesideDis,
        0 - this.helpTextDis,
        textName0,
        'unit'
      )
      this.arrHelpText.push(helpText0)

      // if (!this.isUSTWall && this.searchTabActive === 'CurvedSurface' && this.curveShape === '0' && this.curveCentralAngle !== 0) {
      //   var neDisUP = 120
      //   var getIntersectY = this.getIntersectY()
      //   var textName4 = this.$commonJs.changeUnitDraw(getIntersectY.intersect_left, this.graph.unit, false)
      //   var helpText4 = this.$draw.toText(
      //     this.arrRectPoints[0].x / 2,
      //     0 - this.helpTextDis - neDisUP,
      //     textName4
      //   )
      //   this.arrHelpText.push(helpText4)

      //   textName4 = this.$commonJs.changeUnitDraw(getIntersectY.intersect_right - getIntersectY.intersect_left, this.graph.unit, false)
      //   helpText4 = this.$draw.toText(
      //     (this.arrRectPoints[1].x + this.arrRectPoints[0].x) / 2,
      //     0 - this.helpTextDis - neDisUP,
      //     textName4
      //   )
      //   this.arrHelpText.push(helpText4)

      //   textName4 = this.$commonJs.changeUnitDraw(this.houseInfo.roomW - getIntersectY.intersect_right, this.graph.unit, false)
      //   helpText4 = this.$draw.toText(
      //     (this.houseInfo.roomW + this.arrRectPoints[1].x) / 2,
      //     0 - this.helpTextDis - neDisUP,
      //     textName4
      //   )
      //   this.arrHelpText.push(helpText4)
      // }

      // ==================右辅助文字===============
      let rightText, rightHelpText
      if (this.searchTabActive === 'CurvedSurface') {
        let heightV = this.curveShape === '0' ? this.curveChordLength : this.curveScreenHeight
        rightText = this.$commonJs.changeUnitDraw(heightV, this.graph.unit, false)
        rightHelpText = this.$draw.toText(this.houseInfo.roomW + this.helpBesideDis + this.helpTextDis, this.houseInfo.roomH / 2, rightText, 'right')
        this.arrHelpText.push(rightHelpText)
      } else {
        var neDis = 0
        if (this.$commonJs.changeUnitDraw(this.arrRectPoints[3].z - this.arrRectPoints[0].z, this.graph.unit, false) !== this.$commonJs.changeUnitDraw(this.arrRectPoints[2].z - this.arrRectPoints[1].z, this.graph.unit, false)) {
          neDis = this.helpNeDis
          var textName10 = this.$commonJs.changeUnitDraw(this.arrRectPoints[2].z - this.arrRectPoints[1].z, this.graph.unit, false)
          var helpText10 = this.$draw.toText(
            this.houseInfo.roomW + this.helpBesideDis,
            (this.arrRectPoints[2].z + this.arrRectPoints[1].z) / 2 + lis,
            textName10,
            'right'
          )
          this.arrHelpText.push(helpText10)
        }

        if (!this.isUSTWall && this.searchTabActive === 'Search') {
          var textName1 = this.$commonJs.changeUnitDraw(this.houseInfo.roomH, this.graph.unit, false)
          var helpText1 = this.$draw.toText(
            this.houseInfo.roomW + this.helpTextDis + neDis + this.helpBesideDis,
            this.houseInfo.roomH / 2 + lis,
            textName1,
            'right'
          )
          this.arrHelpText.push(helpText1)
        }
      }
      // 曲面スクリーン機能の改善
      // if (!this.isUSTWall && this.searchTabActive === 'CurvedSurface' && this.curveShape === '1' && this.curveCentralAngle !== 0) {
      //   var getIntersectX = this.getIntersectX()
      //   var textName5 = this.$commonJs.changeUnitDraw(getIntersectX.intersect_top, this.graph.unit, false)
      //   var helpText5 = this.$draw.toText(
      //     this.houseInfo.roomW + this.helpTextDis + neDis + this.helpBesideDis,
      //     this.arrRectPoints[0].z / 2 + lis,
      //     textName5
      //   )
      //   this.arrHelpText.push(helpText5)

      //   textName5 = this.$commonJs.changeUnitDraw(getIntersectX.intersect_bottom - getIntersectX.intersect_top, this.graph.unit, false)
      //   helpText5 = this.$draw.toText(
      //     this.houseInfo.roomW + this.helpTextDis + neDis + this.helpBesideDis,
      //     (this.arrRectPoints[3].z + this.arrRectPoints[0].z) / 2 + lis,
      //     textName5
      //   )
      //   this.arrHelpText.push(helpText5)

      //   textName5 = this.$commonJs.changeUnitDraw(this.houseInfo.roomH - getIntersectX.intersect_bottom, this.graph.unit, false)
      //   helpText5 = this.$draw.toText(
      //     this.houseInfo.roomW + this.helpTextDis + neDis + this.helpBesideDis,
      //     (this.houseInfo.roomH + this.arrRectPoints[3].z) / 2 + lis,
      //     textName5
      //   )
      //   this.arrHelpText.push(helpText5)
      // }

      // ==================左辅助文字===============
      let leftText, leftHelpText, leftTextInfo
      if (this.searchTabActive === 'CurvedSurface') {
        let heightV = this.curveShape === '0' ? this.curveChordLength : this.curveScreenHeight
        let pointX1 = 0 - this.helpTextDis - this.helpBesideDis
        let pointY1 = (this.houseInfo.roomH - heightV) / 2
        let pointY2 = this.$commonViewJs.getAz()
        let pointY3 = (this.houseInfo.roomH + heightV) / 2
        if (pointY1 > pointY2) {
          leftTextInfo = [{text: pointY1 - pointY2, x: pointX1, y: pointY1 - (pointY1 - pointY2) / 2 + lis}]
        } else if (pointY1 < pointY2 && pointY2 < pointY3) {
          leftTextInfo = [
            {text: pointY2 - pointY1, x: pointX1, y: pointY1 + (pointY2 - pointY1) / 2 + lis},
            {text: pointY3 - pointY2, x: pointX1, y: pointY2 + (pointY3 - pointY2) / 2 + lis}
          ]
        } else {
          leftTextInfo = [{text: pointY2 - pointY3, x: pointX1, y: pointY3 + (pointY2 - pointY3) / 2 + lis}]
        }
        leftTextInfo.forEach(item => {
          leftText = this.$commonJs.changeUnitDraw(item.text, this.graph.unit, false)
          leftHelpText = this.$draw.toText(item.x, item.y, leftText, 'left')
          this.arrHelpText.push(leftHelpText)
        })
      } else {
        var textName2 = this.$commonJs.changeUnitDraw(this.arrRectPoints[0].z, this.graph.unit, false)
        var helpText2 = this.$draw.toText(
          0 - this.helpTextDis - this.helpBesideDis,
          this.arrRectPoints[0].z / 2 + lis,
          textName2,
          'left'
        )
        this.arrHelpText.push(helpText2)

        textName2 = this.$commonJs.changeUnitDraw(this.arrRectPoints[3].z - this.arrRectPoints[0].z, this.graph.unit, false)
        helpText2 = this.$draw.toText(
          0 - this.helpTextDis - this.helpBesideDis,
          (this.arrRectPoints[3].z + this.arrRectPoints[0].z) / 2 + lis,
          textName2,
          'left'
        )
        this.arrHelpText.push(helpText2)

        textName2 = this.$commonJs.changeUnitDraw(this.houseInfo.roomH - this.arrRectPoints[3].z, this.graph.unit, false)
        helpText2 = this.$draw.toText(
          0 - this.helpTextDis - this.helpBesideDis,
          (this.houseInfo.roomH + this.arrRectPoints[3].z) / 2 + lis,
          textName2,
          'left'
        )
        this.arrHelpText.push(helpText2)
      }

      // ==================下辅助文字===============
      let bottomText, bottomHelpText, bottomTextInfo
      if (this.searchTabActive === 'CurvedSurface') {
        let widthV = this.curveShape === '0' ? this.curveScreenHeight : this.curveChordLength
        let pointY1 = this.houseInfo.roomH + this.helpTextDis + bs
        let pointX1 = (this.houseInfo.roomW - widthV) / 2
        let pointX2 = this.$commonViewJs.getAx()
        let pointX3 = (this.houseInfo.roomW + widthV) / 2
        if (pointX1 > pointX2) {
          bottomTextInfo = [{text: pointX1 - pointX2, x: pointX1 - (pointX1 - pointX2) / 2, y: pointY1}]
        } else if (pointX1 < pointX2 && pointX2 < pointX3) {
          bottomTextInfo = [
            {text: pointX2 - pointX1, x: pointX1 + (pointX2 - pointX1) / 2, y: pointY1},
            {text: pointX3 - pointX2, x: pointX2 + (pointX3 - pointX2) / 2, y: pointY1}
          ]
        } else {
          bottomTextInfo = [{text: pointX2 - pointX3, x: pointX3 + (pointX2 - pointX3) / 2, y: pointY1}]
        }
        bottomTextInfo.forEach(item => {
          bottomText = this.$commonJs.changeUnitDraw(item.text, this.graph.unit, false)
          bottomHelpText = this.$draw.toText(item.x, item.y, bottomText, 'bottom')
          this.arrHelpText.push(bottomHelpText)
        })
      } else {
        var downNeDis = 0
        if (this.$commonJs.changeUnitDraw(this.arrRectPoints[1].x - this.arrRectPoints[0].x, this.graph.unit, false) !== this.$commonJs.changeUnitDraw(this.arrRectPoints[2].x - this.arrRectPoints[3].x, this.graph.unit, false)) {
          downNeDis = this.helpNeDis
          var textName30 = this.$commonJs.changeUnitDraw(this.arrRectPoints[2].x - this.arrRectPoints[3].x, this.graph.unit, false)
          var helpText30 = this.$draw.toText(
            (this.arrRectPoints[2].x + this.arrRectPoints[3].x) / 2,
            this.houseInfo.roomH + this.helpTextDis + bs,
            textName30,
            'bottom'
          )
          this.arrHelpText.push(helpText30)
        }
        var textName3 = this.$commonJs.changeUnitDraw(this.graph.pjX, this.graph.unit, false)
        var helpText3 = this.$draw.toText(
          this.graph.pjX / 2,
          this.houseInfo.roomH + this.helpTextDis + bs + downNeDis,
          textName3,
          'bottom'
        )
        this.arrHelpText.push(helpText3)
        textName3 = this.$commonJs.changeUnitDraw(this.houseInfo.roomW - this.graph.pjX, this.graph.unit, false)
        helpText3 = this.$draw.toText(
          (this.houseInfo.roomW + this.graph.pjX) / 2,
          this.houseInfo.roomH + this.helpTextDis + bs + downNeDis,
          textName3,
          'bottom'
        )
        this.arrHelpText.push(helpText3)
      }
    },

    onResize () {
      // TODO set conponent size
      this.slider1Height = this.child.$refs.canvas_side.offsetHeight * 0.35 + 'px'
      this.slider2Height = this.slider1Height
      this.vCenterBtnTop = document.getElementsByClassName('front-view-slider-block')[0].offsetTop + this.child.$refs.canvas_side.offsetHeight * 0.35 * 0.5 + 55 + 'px'
      this.child.resizeDraw()
    },

    toCenterV () {
      this.SET_VLENSSHIFT(0)
    },

    toCenterH () {
      this.SET_HLENSSHIFT(0)
    },

    testDigitalNegative (e, key, callBack) {
      e = e.replace(/[^(\-|+)0-9]/ig, '')
      this[key] = Number(e) || 0
      callBack && this[callBack](this[key] * 1)
    },

    setVlensShift (value) {
      if (isNaN(value)) {
        return
      }
      if (this.throw_distance_checked && this.screen_size_checked) {
        if ((this.$commonViewJs.isLongLensExistsLens() && this.$commonViewJs.isLongLensExistsTLens()) || this.selectedModelData.category === 4) {
          this.PJZ(this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2 - this.initScreenSize.h * value / 100))
        } else {
          let temPjz = this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2 - this.initScreenSize.h * value / 100)
          let outRoomHeight = this.$commonViewJs.getMaxOutRoomH(this.initScreenSize.h)
          temPjz = this.$commonJs.checkRange(temPjz, -outRoomHeight + this.limitData, this.houseInfo.roomH - this.limitData)
          this.PJZ(temPjz)
        }
      } else if (this.throw_distance_checked && !this.screen_size_checked) {
        var screenI = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
        if ((this.$commonViewJs.isLongLensExistsLens() && this.$commonViewJs.isLongLensExistsTLens()) || this.selectedModelData.category === 4) {
          this.PJZ(this.houseInfo.roomH - (this.flToB + screenI.calY / 2 - screenI.calY * value / 100))
        } else {
          let temPjz = this.houseInfo.roomH - (this.flToB + screenI.calY / 2 - screenI.calY * value / 100)
          let outRoomHeight = this.$commonViewJs.getMaxOutRoomH(screenI.calY)
          temPjz = this.$commonJs.checkRange(temPjz, -outRoomHeight + this.limitData, this.houseInfo.roomH - this.limitData)
          this.PJZ(temPjz)
        }
      }
      this.$store.commit('SET_VLENSSHIFT', value)
    },

    checkRange (key, max, min) {
      if (isNaN(this[key])) {
        let e = '0'
        this[key] = (e * 1).toFixed(1) * 1
      }
      this[key] = this[key] > max ? max : this[key]
      this[key] = this[key] < min ? min : this[key]
      this.setVlensShift(this[key])
    },
    setHlensShift (value) {
      if (isNaN(value)) {
        return
      }
      if (this.throw_distance_checked && this.screen_size_checked) {
        if ((this.$commonViewJs.isLongLensExistsLens() && this.$commonViewJs.isLongLensExistsTLens()) || this.selectedModelData.category === 4) {
          this.PJX(this.flToL + this.initScreenSize.w / 2 - this.initScreenSize.w * value / 100)
        } else {
          let temPjx = this.flToL + this.initScreenSize.w / 2 - this.initScreenSize.w * value / 100
          let outRoomWidth = this.$commonViewJs.getMaxOutRoomW(this.initScreenSize.w)
          temPjx = this.$commonJs.checkRange(temPjx, -outRoomWidth + this.limitData, this.houseInfo.roomW + outRoomWidth - this.limitData)
          this.PJX(temPjx)
        }
      } else if (this.throw_distance_checked && !this.screen_size_checked) {
        var screenI = this.$commonViewJs.getInitScreenXyFromDist(this.graph.pjY)
        if ((this.$commonViewJs.isLongLensExistsLens() && this.$commonViewJs.isLongLensExistsTLens()) || this.selectedModelData.category === 4) {
          this.PJX(this.flToL + screenI.calX / 2 - screenI.calX * value / 100)
        } else {
          let temPjx = this.flToL + screenI.calX / 2 - screenI.calX * value / 100
          let outRoomWidth = this.$commonViewJs.getMaxOutRoomW(screenI.calX)
          temPjx = this.$commonJs.checkRange(temPjx, -outRoomWidth + this.limitData, this.houseInfo.roomW + outRoomWidth - this.limitData)
          this.PJX(temPjx)
        }
      }
      this.$store.commit('SET_HLENSSHIFT', value)
    },

    checkRangeH (key, max, min) {
      if (isNaN(this[key])) {
        let e = '0'
        this[key] = (e * 1).toFixed(1) * 1
      }
      this[key] = this[key] > max ? max : this[key]
      this[key] = this[key] < min ? min : this[key]
      this.setHlensShift(this[key])
    },

    removeCenter (value) {
      this.position.x = value.x
      this.position.y = value.y + this.$refs.frontView.$el.offsetTop
    }
  },
  watch: {
    vLensShiftData: {
      handler (newValue, oldValue) {
        this.vLensShiftDataInput = this.vLensShiftMax === this.vLensShiftMin ? 0 : Number(newValue.toFixed(0))
      },
      immediate: true
    },
    hLensShiftData: {
      handler (newValue, oldValue) {
        this.hLensShiftDataInput = this.hLensShiftMax === this.hLensShiftMin ? 0 : Number(newValue.toFixed(0))
      },
      immediate: true
    }
    // coverScreenColor () {
    //   console.log('coverScreenColor watch')
    //   this.setArrCurveLinesArea()
    //   // this.setArrCurveRect()
    // }
  }
}
</script>

<style scoped>
.front-view {
  position: relative;
  height: 100%;
  width: 100%;
  border-bottom: none;
  overflow: hidden;
  background: #fff;
}
.inline {
  width: 50%;
  height: 42px;
  border: 1px solid #cccccc;
  background: #f0f0f0;
  border-radius: 5px;
  display: inline-block;
}
.slider-h {
  background: #fff;
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  float: left;
  width: calc(100% - 75px);
  min-width: 143px;
}
.horizontal {
  line-height: 12px;
  font-size: 12px;
  position: absolute;
  bottom:0;
  transform: translateX(-50%);
  left: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 70px;
}
.none {
  visibility: hidden;
  margin-bottom: 7px;
}
.front-img {
  background: url('../../assets/parts/icon/icon_front.png') no-repeat center;
  width: 30px;
  height: 30px;
  float: left;
}

.el-slider__runway {
  background-color: #999999;
  margin: 20px 10px;
  height: 2px;
  border-radius: 0px;
  width: calc(100% - 20px);
}

.slider-input-panel {
  float: left;
  position: relative;
  width: 75px;
  text-align: center;
  height: 100%;
}

.red >>> .el-input__inner {
  border: 2px solid #F56C6C;
}

.front-view >>> .canvas_side {
  text-align: center;
  width: calc(100% - 55px);
  height: calc(100% - 128px);
  position: absolute;
  bottom: 48px;
  top: 80px;
}

.middle-btndis{
  background: #DCDFE6;
  position: absolute;
  text-align: center;
  font-size: 12px;
  line-height: 23px;
  height: 23px;
  color: rgb(180, 180, 180);
  border-radius: 4px;
  cursor: pointer;
  transform: translate(-50%, -15px);
  padding: 0 10px;
}

.middle-btn {
  position: absolute;
  text-align: center;
  font-size: 12px;
  line-height: 23px;
  height: 23px;
  background: rgb(0, 50, 152);
  color: rgb(255, 255, 255);
  border-radius: 4px;
  cursor: pointer;
  transform: translate(-50%, -15px);
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/graph/frontView.vue